import { Link } from 'react-router-dom';
import { useApi } from '../hooks/useApi.js';
import { fetchSiteSettings } from '../lib/api.js';

/**
 * Full-bleed "Start the journey" CTA at the bottom of the homepage.
 * Mirrors `section.journey` from design-source/index.html lines 1536-1550.
 *
 * All copy lives in SiteSettings.journeyBand (admin-managed). A small
 * fallback object keeps the band rendering if the API is unreachable.
 */
const FALLBACK = {
  eyebrow: 'Start the journey',
  rawTitle: 'An education for <em>life</em>',
  body: "From your first campus visit through to graduation — and every milestone in between — we'd love to welcome you into the {schoolName} family.",
  actions: [
    { label: 'Enquire Now',  to: '/contact',   style: 'gold' },
    { label: 'School Tours', to: '/contact',   style: 'outline' },
    { label: 'Apply Now',    to: '/admission', style: 'outline' },
  ],
};

const isExternal = (to) => /^https?:\/\//i.test(to || '');
const btnClass = (style) => (style === 'gold' ? 'btn btn-gold' : 'btn btn-outline');

export function JourneyBand() {
  const { data: settings } = useApi(fetchSiteSettings, []);
  const logo = settings?.logo || '/img/mlis-logo.jpg';
  const name = settings?.schoolName || 'Maple Leaf International School';
  const band = (settings?.journeyBand && typeof settings.journeyBand === 'object')
    ? settings.journeyBand
    : FALLBACK;
  const actions = Array.isArray(band.actions) && band.actions.length ? band.actions : FALLBACK.actions;
  const body = String(band.body || FALLBACK.body).replace(/\{schoolName\}/g, name);

  return (
    <section className="journey">
      <div className="journey-bg" />
      <div className="container journey-inner reveal">
        <div className="journey-mark">
          <img src={logo} alt={name} width="64" height="64" loading="lazy" />
        </div>
        {band.eyebrow && (
          <div className="section-eyebrow" style={{ color: 'var(--gold-soft)' }}>{band.eyebrow}</div>
        )}
        {band.rawTitle && (
          <h2 dangerouslySetInnerHTML={{ __html: band.rawTitle }} />
        )}
        <p>{body}</p>
        <div className="journey-actions">
          {actions.map((a, i) => (
            isExternal(a.to)
              ? <a key={i} href={a.to} className={btnClass(a.style)} target="_blank" rel="noreferrer">{a.label}</a>
              : <Link key={i} to={a.to || '/'} className={btnClass(a.style)}>{a.label}</Link>
          ))}
        </div>
      </div>
    </section>
  );
}
